import React, { useState } from "react";
import SortTwoToneIcon from "@mui/icons-material/SortTwoTone";
import { useNavigate } from "react-router";

const FindProjectCard = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  const [cardColor, setCardColor] = useState(false);
  const navigate = useNavigate();
  const handleCardColorChange = () => {
    setCardColor(true);
  };

  const handleCardColorRemove = () => {
    setCardColor(false);
  };

  const handleNavigation = () => {
    const path = "/projects";
    navigate(path);
  };
  return (
    <div
      onClick={
        title === "Projects" ? () => navigate("/projects") : handleNavigation
      }
      className={`homeCardsView__container__projectCards__card ${cardColor ? `homeCardsView__container__projectCards__cardProject` : ""}`}
      onMouseEnter={handleCardColorChange}
      onMouseLeave={handleCardColorRemove}
    >
      <div className="homeCardsView__container__projectCards__card__iconBox">
        {title === "Projects" ? (
          <SortTwoToneIcon className="homeCardsView__container__projectCards__cardProject__iconBox__iconProject" />
        ) : (
          <SortTwoToneIcon
            className={`homeCardsView__container__projectCards__card__iconBox__icon ${cardColor ? `homeCardsView__container__projectCards__cardProject__iconBox__iconProject` : ""}`}
          />
        )}
      </div>
      <p>{title}</p>
      <span>{description}</span>
    </div>
  );
};

export default FindProjectCard;
